import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const speakersSlice = createAppSlice({
  name: 'speakers',
  initialState,
  reducers,
});

export const { fetchSpeakersPage, fetchSpeakersByIds, updateSpeaker, upsertSpeaker } = speakersSlice.actions;

export default speakersSlice.reducer;
